import React from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';

const IconContainer = styled('div', { shouldForwardProp })(
  css({
    height: '40px',
    width: '40px',
    position: 'absolute',
    bottom: '0px',
    right: '50%',
    transform: 'translate(50%,50%)',
    borderRadius: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '10',
    backgroundColor: 'neutral.0',
  })
);

const SystemModalIcon = ({ children }) => {
  return <IconContainer>{children}</IconContainer>;
};

export default SystemModalIcon;
